import React from 'react';
import { Zap } from 'lucide-react';
import { fmtXp, iconFor, whenLabel } from '../utils/gamification';
import './LevelCard.css';

const R = 50;
const C = 2 * Math.PI * R;

/** Nível no curso: anel de progresso, XP que falta para o próximo nível e últimas medalhas.
 *  embedded: sem fundo próprio, para ocupar o topo azul de um ScoreCard. */
function LevelCard({ data, embedded = false }) {
  const { level, xp, levelXp, nextLevelXp, pct, todayXp, globalXp, recentAchievements = [] } = data;
  const remaining = nextLevelXp - levelXp;

  return (
    <section className={`lvl-card ${embedded ? 'lvl-card--embedded' : ''}`} aria-label={`Nível ${level} no curso`}>
      <div className="lvl-card__ring">
        <svg viewBox="0 0 120 120" aria-hidden="true">
          <circle cx="60" cy="60" r={R} className="lvl-card__track" />
          <circle
            cx="60"
            cy="60"
            r={R}
            className="lvl-card__value"
            strokeDasharray={`${(pct / 100) * C} ${C}`}
            transform="rotate(-90 60 60)"
          />
        </svg>
        <div className="lvl-card__level">
          <span>Nível</span>
          <strong>{level}</strong>
        </div>
      </div>

      <div className="lvl-card__main">
        <span className="ss-badge lvl-card__today">
          <Zap size={13} strokeWidth={2.4} aria-hidden="true" />
          {todayXp > 0 ? `+${fmtXp(todayXp)} XP hoje` : '0 XP hoje'}
        </span>
        <h2>Faltam {fmtXp(remaining)} XP para o nível {level + 1}</h2>
        <div className="lvl-card__progress">
          <span
            className="lvl-card__bar"
            role="progressbar"
            aria-valuenow={pct}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label="Progresso no nível"
          >
            <span style={{ width: `${pct}%` }} />
          </span>
          <span className="lvl-card__legend">
            <span>{fmtXp(levelXp)} / {fmtXp(nextLevelXp)} XP neste nível</span>
            <span>{fmtXp(xp)} XP no curso · {fmtXp(globalXp)} no total</span>
          </span>
        </div>
      </div>

      <div className="lvl-card__recent">
        <span className="lvl-card__eyebrow">Últimas conquistas</span>
        {recentAchievements.length === 0 ? (
          <p className="lvl-card__empty">Conclua uma aula ou seja aprovado num simulado para ganhar a primeira medalha.</p>
        ) : recentAchievements.map(a => {
          const Icon = iconFor(a.icon);
          return (
            <div key={a.key} className="lvl-card__medal">
              <span className="lvl-card__medalicon"><Icon size={18} aria-hidden="true" /></span>
              <span className="lvl-card__medaltext">
                <strong>{a.name}</strong>
                <span>{whenLabel(a.unlockedAt)} · +{a.xp} XP</span>
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default LevelCard;
